'use client';
import { useState, useEffect } from 'react';
import { getAuthToken } from '@/utils/auth';

const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;

export function useUserProfile() {
  const [user, setUser] = useState(null);
  const [school, setSchool] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const token = getAuthToken();
      if (!token || !API_BASE_URL) {
        setIsLoading(false);
        return;
      }

      let role = null;
      try {
        const payload = JSON.parse(atob(token.split('.')[1] || ''));
        role = payload?.role || null;
      } catch (err) {
        console.error('[useUserProfile] Failed to decode token payload', err);
      }

      try {
        const headers = { Authorization: `Bearer ${token}` };

        const apiBase = API_BASE_URL || '';

        if (role === 'superadmin') {
          // Fetch current super admin profile and system settings (business profile)
          const [res, settingsRes] = await Promise.all([
            fetch(`${apiBase}/api/super-admin/me`, { headers }),
            fetch(`${apiBase}/api/system-settings`, { headers }),
          ]);
          const data = await res.json().catch(() => ({}));
          if (res.ok) {
            setUser(data.user || null);
          }
          const settingsData = await settingsRes.json().catch(() => ({}));
          const settings = settingsData.settings || {};
          setSchool({
            schoolName: settings.businessName || 'Kaympus ',
            shortName: 'Kayease',
            logoUrl: settings.logoUrl || '/logo.png',
          });
        } else {
          // Regular school user (schooladmin / teacher / student / staff)
          const [userRes, schoolRes] = await Promise.all([
            fetch(`${apiBase}/api/users/me`, { headers }),
            fetch(`${apiBase}/api/schools/me`, { headers }),
          ]);

          if (userRes.ok) {
            const userData = await userRes.json();
            setUser(userData.user || null);
          }

          if (schoolRes.ok) {
            const schoolData = await schoolRes.json();
            setSchool(schoolData.school || null);
          }
        }
      } catch (err) {
        console.error('Failed to fetch user/school profile:', err);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  return { user, school, isLoading, error };
}

